import { AntValidationError } from 'src/common/types'

export const getErrorFields = (errors: AntValidationError) =>
  errors?.errorFields
    .filter((error: any) => error.name.includes('responses'))
    .map((value: any) => value.name[1])
